import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AventuraService } from 'src/app/services/api/aventura.service';
import Swal from 'sweetalert2';
import { DialogAsignarProductoComponent } from './dialog-asignar-producto/dialog-asignar-producto.component';
import { Observable, map, startWith } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-categoria-agrupado',
  templateUrl: './categoria-agrupado.component.html',
  styleUrls: ['./categoria-agrupado.component.css']
})
export class CategoriaAgrupadoComponent implements OnInit {

  activeCategory:any

  categorias: any = [];

  agrupado:any[]=[]

  categoriaAgrupado:string=""

  showNewAgrupado:boolean=false;
  showTable:boolean=false;
  showForm:boolean=false;

  displayedColumns: string[] = [
    'nombre',
    'modificar',
    'asignarProducto',
    'eliminar'
  ];

  HeaderList: string[] = ['nombre','marca','modelo','talla'];
  paxColumns: string[] = Array.from({ length: 30 }, (_, i) => `pax${i + 1}`);
  HeaderActions: string[] = ['editar','eliminar'];

  editMode: boolean = false;

  dataSource: any;
  dataSourceAgrupado: any;
  loading: boolean = true;

  filteredOptions!: Observable<any[]>;
  filteredOptionsMarca!: Observable<any[]>;
  filteredOptionsModelo!: Observable<any[]>;

  listaEquipos: any[]=[];
  listaNombres: any[]=[];
  listaMarcas: any[]=[];
  listaModelos: any[]=[];

  agrupadoControl = new FormControl<string>('');

  nombreControl = new FormControl<string>('');
  marcaControl = new FormControl<string>('');
  modeloControl = new FormControl<string>('');

  newEquipo:any

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  
  constructor(private almacenService: AventuraService,public dialog: MatDialog,) { }

  ngOnInit() {

    console.log(this.nombreControl)
    this.getAllCategorias();
    this.getAllEquipos()

    this.filteredOptions = this.nombreControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = value;
        return nombre ? this._filter(nombre as string,"nombre") : this.listaNombres.slice();
      }),
    );

    this.filteredOptionsMarca = this.marcaControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = value;
        return nombre ? this._filter(nombre as string,"marca") : this.listaMarcas.slice();
      }),
    );

    this.filteredOptionsModelo = this.modeloControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = value;
        return nombre ? this._filter(nombre as string,"modelo") : this.listaModelos.slice();
      }),
    );
  }

  toggleEditMode(element: any) {
    element.editMode = !element.editMode;
    
  }

  toggleEditModeNombreAgrupado() {
    this.showNewAgrupado=true
    
  }

  saveChanges(element:any){
    //update pax config de element
    delete element.editMode
    if(this.newEquipo){

      //falta equipoId
      console.log(this.newEquipo)
      this.almacenService.createAgrupadoEquipo(this.newEquipo).subscribe(res=>{
        console.log(res)
        element.id=res.createAgrupadoEquipo.id
        element.editMode = false;
        this.newEquipo=null
      })
    }
    else{
      this.almacenService.updateAgrupadoEquipo(element.id,element).subscribe(res=>{
        element.editMode = false;
      })
    }


  }

  getAllCategorias() {
    this.almacenService.getAllCategorias().subscribe((response) => {
      this.categorias = response.getAllCategorias;

      console.log(this.categorias)
      this.dataSource = new MatTableDataSource(this.categorias);
      //this.dataSource.paginator = this.paginator
      this.loading=false
      return response;
    });

  }

  viewAgrupado(id:any,nombre:string){
    this.showNewAgrupado=false
    this.nombreControl.setValue('')
    this.marcaControl.setValue('')
    this.modeloControl.setValue('')

    if(this.activeCategory?.id===id){
      this.showTable=false
      this.agrupadoControl.setValue("")
      this.activeCategory=null
    }
    else{
      this.activeCategory={id,nombre}

      this.almacenService.getAllAgrupadoEquipoByCategoriaId(id).subscribe((res:any)=>{
        this.agrupado=res.getAllAgrupadoEquipoByCategoriaId
        this.agrupado = this.agrupado.sort((a, b) => a.nombreEquipo.localeCompare(b.nombreEquipo));
        
        this.dataSourceAgrupado = new MatTableDataSource(this.agrupado);
        this.dataSourceAgrupado.paginator = this.paginator
        
        this.agrupadoControl.setValue(nombre)
        this.showTable=true
  
      })
    }


    
  }

  addAgrupado(){

    this.dataSourceAgrupado = new MatTableDataSource();
    this.activeCategory=null
    this.agrupadoControl.setValue("")
    this.showNewAgrupado=true
    this.showTable=false
    
  }

  setShowForm(){
    this.showForm=!this.showForm
  }

  addEquipo(){

    console.log(this.dataSourceAgrupado.data)
    const item=this.listaEquipos.find((equipo:any)=>equipo.nombre===this.nombreControl.value && equipo.marca=== this.marcaControl.value && equipo.modelo===this.modeloControl.value)
    console.log(item)
    const obj={
      categoriaId:this.activeCategory.id,
      categoriaNombre:this.activeCategory.nombre,
      equipoId:item.id,
      marcaEquipo:item.marca,
      modeloEquipo:item.modelo,
      nombreEquipo:item.nombre,
      pesoEquipo:item.peso,
      nroPersonasPax:new Array(30).fill(''),
      editMode:true
    }

    this.newEquipo=obj

    const newData=this.dataSourceAgrupado.data

    newData.unshift(obj)

    this.dataSourceAgrupado.data=newData

    this.nombreControl.setValue("")
    this.marcaControl.setValue("")
    this.modeloControl.setValue("")

    
  }

  openDialogAsignarProducto(element:any): void {

    let dialogConfig=new MatDialogConfig();
    dialogConfig.data={
      data:element
    };
    dialogConfig.width="60rem";
    dialogConfig.height="500px";

    let dialogRef = this.dialog.open(DialogAsignarProductoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result:any) => {
      console.log("closed");
      console.log(result);
/*       if(result==1){
        this.getAllEquipos();
      } */
    });
  }

  deleteCategoria(categoria: any,i:number): void {

    Swal.fire({
      title: 'Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {

        this.almacenService.deleteCategoria(categoria.id).subscribe((data: any)=>{
          console.log(data);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'El registro se eliminó satisfactoriamente.',
            showConfirmButton: false,
            timer: 4000
          });
          if(this.activeCategory?.id===categoria.id){
            this.showTable=false
            this.agrupadoControl.setValue('')
          }
          this.getAllCategorias();
        })

      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
        console.log("false");
      }
    })

  }

  getAllEquipos(){
    this.almacenService.getAllEquipos().subscribe(response=>{
      this.listaEquipos=response.getAllEquipos;

      const nombre = this.listaEquipos.filter((item: any) => item.nombre !== '' && item.nombre !== null).map((item: any) => (item.nombre))
      this.listaNombres= [...new Set(nombre)]
    
      this.loading=false
    });
  }

  onSelectionChangedEquipo(event: MatAutocompleteSelectedEvent) {
    console.log(event.option.value)
    const marca = this.listaEquipos.filter((item: any) => item.nombre===event.option.value).map((item: any) => (item.marca))
    this.listaMarcas= [...new Set(marca)]

    console.log(this.listaMarcas)

  }

  onSelectionChangedMarca(event: MatAutocompleteSelectedEvent) {
    console.log(event.option.value)
    const modelo = this.listaEquipos.filter((item: any) => item.marca===event.option.value && item.nombre===this.nombreControl.value).map((item: any) => (item.modelo))
    this.listaModelos= [...new Set(modelo)]

    console.log(this.listaModelos)
  }

  private _filter(nombre: string,option:string): any[] {
    const filterValue = nombre.toLowerCase();

    console.log(filterValue)
    console.log(this.listaNombres)
    if(option==="nombre"){
      
      return this.listaNombres.filter((option) => option.toLowerCase().includes(filterValue));
    }
    else if(option==="marca"){

      return this.listaMarcas.filter((option) => option.toLowerCase().includes(filterValue));
    
    }
    else{
      return this.listaModelos.filter((option) => option.toLowerCase().includes(filterValue));
    }

  }

  deleteEquipo(element:any,i:any){

    this.almacenService.deleteAgrupadoEquipo(element.id).subscribe(res=>{
      console.log(res)

      const pageIndex = this.dataSourceAgrupado.paginator.pageIndex;
      const pageSize = this.dataSourceAgrupado.paginator.pageSize;
      const globalIndex = pageIndex * pageSize + i;
  
      this.dataSourceAgrupado.data.splice(globalIndex, 1);
      this.dataSourceAgrupado._updateChangeSubscription();

    })
  }


  addAgrupadoNombre(){

    if(this.agrupadoControl.value!==''){
      if(!this.activeCategory){
        this.almacenService.createCategoria({nombre:this.agrupadoControl.value}).subscribe(res=>{
          const newData=this.dataSource.data
          newData.push({id:res.createCategoria.id,nombre:this.agrupadoControl.value,productos:[]})
    
          this.dataSource=newData
    
          this.showNewAgrupado=false
          this.activeCategory={id:res.createCategoria.id,nombre:this.agrupadoControl.value}
    
          this.dataSourceAgrupado = new MatTableDataSource();
          this.dataSourceAgrupado.paginator = this.paginator
          this.showTable=true
        })
      }
      else{
        this.almacenService.updateCategoria({nombre:this.nombreControl.value},this.activeCategory.id).subscribe(res=>{
          this.showNewAgrupado=false
        })
      }
    }
    else{
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'Ingrese un nombre para la categoría',
        showConfirmButton: false,
        timer: 4000
      });
    }






  }
}
